export default "__VITE_ASSET__C_KizhxB__"